// Enabler E7-C (ADO-2274): SL1.0's picked-fresh availability text. A picked-fresh product has no
// stock state and is always orderable (E7-B, ADO-2273; MP AVL-5.4), so the availability read
// leaves it out and no stock pill can show. SL1.0 shows these two messages in that place
// (`www/engine/stock_and_subs.php:35-41`, `getAvailabilityInfoPickedFreshMsg`).

/**
 * The short form, which SL1.0's product rows show (`get_rbp_npr.php:319`): the card and PDP pill,
 * and the search typeahead row's stock label.
 */
export const PICKED_FRESH_LABEL = 'Picked fresh';

/**
 * The long form, after SL1.0's "Availability Info:" prefix, which its product detail row shows
 * (`get_smanager.php:3906`, `cabinet_smanager.htm:2419`): the PDP's Availability row.
 */
export const PICKED_FRESH_MESSAGE = 'Picked fresh daily, local cut off times apply.';

/**
 * Whether the picked-fresh text stands in for the stock state: the product is picked fresh and
 * there is no availability entry for it. An entry, should one ever arrive, is shown as it is.
 */
export function showsPickedFresh(
  product: { readonly isPickedFresh: boolean },
  availability: unknown,
): boolean {
  return product.isPickedFresh && availability === undefined;
}
